<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="设备编号" v-model="deviceId"></el-input>
      </el-col>
      <el-col :span="10">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column prop="sendTime" label="下发时间"> </el-table-column>
      <el-table-column prop="content" label="内容"> </el-table-column>
      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column prop="id" label="seq"> </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      deviceId: "",
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      env: this.getEnv(),
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      this.$http
        .post(`${this.env}/manage/device-mqtt-downlink/listHis`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },
  },
  components: { Pagination },
};
</script>